
<h2 mat-dialog-title>Are you sure you want to cancel adding this property ?</h2>
<mat-dialog-content>
    <div  style="width: 100%; color: #444746; font-size: 12px; font-family: Roboto; font-weight: 400; line-height: 19.92px; letter-spacing: 0.40px; word-wrap: break-word">
        All data provided up to this point will be lost. If you cancel now, you will need to start the process again..</div>
</mat-dialog-content>
<div mat-dialog-actions [align]="'end'" name="hi">
    <button  mat-stroked-button mat-button mat-dialog-close class="button-stepper-allow">
        GO BACK
        <mat-icon>arrow_left_alt</mat-icon>
     </button>
  <button class="button-dialog-red" [routerLink]="['/app/properties']" routerLinkActive="active" mat-button mat-dialog-close cdkFocusInitial>CANCEL PROCESS</button>
</div>
